import { Button } from '@gr-monorepo/common/ui';
import styled from 'styled-components';

export const WrapKpk = styled.div`
  display: flex;
  gap: 24px;
`;

export const Container = styled.div`
  width: 456px;
  min-height: 645px;
  padding: 32px 24px;
  border-radius: 20px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const WrapDescription = styled.div`
  display: grid;
  gap: 16px;
`;

export const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
`;
export const TextFooter = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
`;

export const Description = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
`;

export const Span = styled.span`
  font-weight: 700;
`;

export const ButtonPlate = styled(Button)`
  width: 331px;
  height: 41px;
  font-weight: 700;
  font-size: 14px;
  text-decoration: uppercase;
  border-radius: 8px;
`;

export const ButtonModal = styled(Button)`
  width: 200px;
  border-radius: 8px;
`;

export const TitleModal = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
`;

export const ItemListWrap = styled.div`
  display: flex;
  gap: 10px;
`;
